import type { ReactNode } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "../Button";
import { cx } from "../cx";
import { FilterChip, LinkButton } from "../Filters";

export function FilterSidebar({ label, open, children }: { label: string; open: boolean; children: ReactNode }) {
  return (
    <div
      className={cx(
        "flex max-compact:absolute max-compact:inset-y-0 max-compact:left-0 max-compact:z-overlay max-compact:shadow-pop",
        !open && "max-compact:hidden",
      )}
    >
      <nav
        aria-label={label}
        className="w-sidebar flex-none overflow-auto border-r border-divider bg-bg px-2.5 py-3.5 text-ui"
      >
        {children}
      </nav>
    </div>
  );
}

export function FiltersButton({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  return (
    <Button size="sm" className="compact:hidden" aria-expanded={open} onClick={onToggle}>
      <SlidersHorizontal aria-hidden="true" />
      Filters
    </Button>
  );
}

export interface ActiveFilter {
  readonly key: string;
  readonly label: string;
  readonly value: ReactNode;
  readonly onRemove: () => void;
}

export function ActiveFilters({ filters, onReset }: { filters: readonly ActiveFilter[]; onReset: () => void }) {
  return (
    <>
      {filters.map((f) => (
        <FilterChip key={f.key} label={f.label} value={f.value} onRemove={f.onRemove} />
      ))}
      {filters.length > 0 ? <LinkButton onClick={onReset}>Reset all</LinkButton> : null}
    </>
  );
}
